import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/user-invites/get/list.ts
var list_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var RoleSchema = z.object({
	id: z.string(),
	name: z.string()
});
var StreamProfileSchema = z.object({
	canSetCues: z.boolean(),
	id: z.string()
});
var UserInviteSchema = z.object({
	createdDate: z.string(),
	email: z.string(),
	first: z.string(),
	last: z.string(),
	roles: z.array(RoleSchema),
	streamProfiles: z.array(StreamProfileSchema),
	title: z.string(),
	uuid: z.string()
});
var ResponseSchema = z.array(UserInviteSchema);
var parse = parseFactory(ResponseSchema);
//#endregion
export { list_exports };

//# sourceMappingURL=list.js.map